// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"homePage_visuallyHidden__07q8m"};